var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetModuleListQuery } from "@/store/api";
import { useGenerateDistinctColors } from "@/pages/administration/colorGenerator";
import { useAppSelector } from "@/hooks/store";
/** <b>Composant en mode consultation/detail d'un champ de type enum</b>*/
export default function EnumFieldDetail(_a) {
    var _b, _c, _d;
    var fieldName = _a.fieldName, record = _a.record, fieldMetadata = _a.fieldMetadata, moduleName = _a.moduleName;
    var t = useTranslation().t;
    var _e = useAppSelector(function (state) { return state.theme; }), colorBase = _e.colorBase, midColor = _e.midColor, endColor = _e.endColor;
    var defaultValue = useMemo(function () {
        if (!record) {
            return;
        }
        return record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    //bg avec paletteCouleur:
    var moduleList = useGetModuleListQuery({
        table: moduleName,
        params: {
            count: false,
        },
    }).data;
    var values = (_b = moduleList === null || moduleList === void 0 ? void 0 : moduleList.data) === null || _b === void 0 ? void 0 : _b.records.map(function (record) { return record[fieldName]; });
    var filteredValues = Array.from(new Set((_d = (_c = values === null || values === void 0 ? void 0 : values.filter(function (value) { return value !== null; })) === null || _c === void 0 ? void 0 : _c.flatMap(function (value) { return value === null || value === void 0 ? void 0 : value.split("^"); })) === null || _d === void 0 ? void 0 : _d.filter(Boolean))).sort();
    var durationText = function (seconds) {
        var units = [
            {
                labelSingular: t("app.LBL_DURATION_DAY", { ns: "common" }),
                labelPlural: t("app.LBL_DURATION_DAYS", { ns: "common" }),
                seconds: 24 * 3600,
            },
            {
                labelSingular: t("app.LBL_DURATION_HOUR", { ns: "common" }),
                labelPlural: t("app.LBL_DURATION_HOURS", { ns: "common" }),
                seconds: 3600,
            },
            {
                labelSingular: t("app.LBL_DURATION_MINUTE", { ns: "common" }),
                labelPlural: t("app.LBL_DURATION_MINUTES", { ns: "common" }),
                seconds: 60,
            },
        ];
        var remainingSeconds = seconds;
        var result = "";
        units.forEach(function (unit) {
            if (remainingSeconds >= unit.seconds) {
                var value_1 = Math.floor(remainingSeconds / unit.seconds);
                remainingSeconds %= unit.seconds;
                result += "".concat(value_1, " ").concat(value_1 > 1 ? unit.labelPlural : unit.labelSingular, " ");
            }
        });
        return result.trim();
    };
    var isMeetings = moduleName === "Meetings";
    var options = function () {
        if (!fieldMetadata || !fieldMetadata.options) {
            return [];
        }
        var optionsObejct = t("app_lists")[fieldMetadata.options] || {};
        var values = [];
        for (var p in optionsObejct) {
            values.push({ value: p, label: optionsObejct[p] });
        }
        return values;
    };
    var optionList = options();
    var getLabelFromValue = function (value) {
        var option = optionList && (optionList === null || optionList === void 0 ? void 0 : optionList.find(function (opt) { return opt.value == value; }));
        return option ? option.label : undefined;
    };
    var durationValue = record[fieldName] || "";
    var _f = useState(getLabelFromValue(record[fieldName])), value = _f[0], setValue = _f[1];
    useEffect(function () {
        if (fieldName === "duration" && moduleName === "Meetings" && record) {
            var duration_hours = record["duration_hours"];
            var duration_minutes = record["duration_minutes"];
            var duration = record[fieldName];
            if (duration !== "") {
                var v = getLabelFromValue(duration);
                var vl = durationText(duration);
                if (v !== undefined) {
                    setValue(v);
                }
                else {
                    setValue(vl);
                }
            }
            else {
                var heuresEnSeconde = duration_hours * 3600;
                var minutesEnSeconde = duration_minutes * 60;
                var v = heuresEnSeconde + minutesEnSeconde;
                var durationString = getLabelFromValue(v);
                if (durationString !== undefined) {
                    setValue(durationString);
                }
                else {
                    setValue(durationText(v));
                }
            }
        }
    }, [fieldName, moduleName, record]);
    var numColors = "8";
    var shade = "400";
    var algo = "goldenRatio";
    var colors = useGenerateDistinctColors({
        numColors: numColors,
        shade: shade,
        colorBase: colorBase,
        algo: algo,
        endColor: endColor,
        midColor: midColor,
    }) || [];
    var colorMapping = useMemo(function () {
        return filteredValues.reduce(function (acc, val, index) {
            acc[val] = colors[index % colors.length]; // Attribution cyclique des couleurs si palette insuffisante
            return acc;
        }, {});
    }, [filteredValues, colors]);
    var backgroundColor = colorMapping[defaultValue] || "#e0e0e0";
    //const { hue, saturation, lightness } = extractHSLValues(backgroundColor);
    //const textColor = darkenColor(hue, saturation, lightness, 40);
    return (_jsx("span", __assign({ className: "flex items-center" }, { children: _jsx("span", __assign({ className: "border border-none rounded px-2", style: {
                backgroundColor: backgroundColor,
                color: "#ffffff",
            } }, { children: isMeetings && fieldName === "duration" ? value : defaultValue })) })));
}
